import { Box } from "@mui/material";
import { Link } from "../../../types/Link";
import LinkCard from "../LinkCard/LinkCard";
import * as styles from "./linksItemStyles";

interface LinksItemProps {
    links: Link[];
}

const LinksItem: React.FC<LinksItemProps> = ({ links }) => {
    return (
        <Box sx={styles.linksItemWrapperStyles}>
            {links.map((link, i) => (
                <LinkCard key={i} {...link} />
            ))}
        </Box>
    );
};

export default LinksItem;
